// extracted by mini-css-extract-plugin
module.exports = {"placeHolderShimmer":"app__placeHolderShimmer___a8wN_"};